const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  roles: state => state.user.roles,
  categoryMaintenanceList: state => state.maintenance.categoryMaintenanceList
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js